import { IDeductionRepository, IUpdateDeductionDetailsRepositoryParams, IUpdateDeductionDetailsRepositoryResponse } from "@/core/repositories/deduction";

export class UpdateDeductionDetailsUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IUpdateDeductionDetailsRepositoryParams, currentPage: number): Promise<IUpdateDeductionDetailsRepositoryResponse> {
    return this.deductionRepository.updateDeductionDetails(params, currentPage);
  }
}  
